import React from "react"

import Layout from "../components/Layout"
import SEO from "../components/seo"
import ContentBlock from "../components/block-element"
import { graphql, Link } from "gatsby"
import AliceCarousel from "react-alice-carousel"
import TextLoop from "react-text-loop"
import moment from "moment"
import { cgblue, cggreen } from "../components/colors"
import Logos from "../images/Logos"
import ContactForm from "../components/ContactForm"
import { ContactUsButton } from "../components/ContactModal"
import Img from "react-cloudinary-lazy-image"

import AniLink from "gatsby-plugin-transition-link/AniLink"

if (typeof window !== "undefined") {
  require("smooth-scroll")('a[href*="#"]', {
    speed: 500,
    speedAsDuration: true,
  })
}

const IndexPage = ({ data }) => {
  const topThreePosts = [...data.allMarkdownRemark.edges]
  const serviceBlocks = [...data.allHomeServiceJson.edges]
  const testimonials = [...data.allTestimonialsJson.edges]

  return (
    <Layout>
      <SEO title="Home" />
      <div>
        <div className="hero index-hero hero-text-center">
          <div>
            <h1>
              We do{" "}
              <TextLoop
                className="text-loop"
                interval={3000}
                fade={false}
                mask={true}
                springConfig={{ stiffness: 200, damping: 18 }}
                children={[
                  " Cybersecurity",
                  " Offensive Security",
                  " PCI Compliance",
                  " Data Remediation",
                  " Forensics",
                ]}
              />
            </h1>
            <h3>Achieve your mission, securely.<sup><small><small><small><small>TM</small></small></small></small></sup></h3>
            <Link to="#services" className="button-component white-button">
              <span>LEARN MORE</span>
            </Link>
          </div>
        </div>
      </div>
      {/* Services Section and ID required so navbar links will work */}
      <section id="services" className="home-service-carousel">
        <AliceCarousel
          autoPlay={true}
          autoPlayInterval={7000}
          disableAutoPlayOnAction={true}
          items={generateHomeServices(serviceBlocks)}
        />
      </section>
      <section className="testimonials">
        <div
          className="text-content"
          style={{ paddingTop: "70px", paddingBottom: "65px" }}
        >
          <h2 style={{ color: cggreen }}>Testimonials</h2>
          <div className="container quote-bg">
            <AliceCarousel
              autoPlay={true}
              autoPlayInterval={5000}
              items={generateTestimonials(testimonials)}
            ></AliceCarousel>
          </div>
        </div>
      </section>
      <div
        className="content-block "
        style={{
          background: `radial-gradient(rgb(30, 97, 142), rgb(0, 72, 119) 50%)`,
        }}
      >
        <div>
          <div className="container">
            <div
              className="text-content"
              style={{ color: "white", width: "800px", maxWidth: "90vw" }}
            >
              <h2>About Us</h2>
              <br />
              <br />
              <h3>
                Control Gap helps businesses safeguard sensitive data, reduce
                security risks and avoid breaches.
              </h3>
              <p style={{ width: "600px", maxWidth: "90vw", margin: "auto" }}>
                We are home to some of the best and most tested information
                security talent in the industry.
              </p>
              <AniLink
                className="button-component white-button"
                style={{ color: "white", borderColor: "white" }}
                fade
                to={"/about-us"}
              >
                <span>Who We Are</span>
              </AniLink>
            </div>
          </div>
        </div>
      </div>
      <div
        className={"content-block blog-content-block"}
        style={{
          position: "relative",
          paddingBottom: "100px",
          background:
            "linear-gradient(103deg,rgb(255, 255, 255) 0%, rgba(203, 203, 203) 100%)",
        }}
      >
        <div className="container">
          <div className="text-content" style={{ color: cgblue }}>
            <h2>What's New</h2>
            <br />
            <div className="blog-container" style={{ margin: 0 }}>
              <IndexBlogPosts topThreePosts={topThreePosts} />
            </div>
            <br />
            <AniLink
              fade
              to="/blog"
              className="button-component"
              style={{ margin: "40px auto" }}
            >
              <span>See more posts</span>
            </AniLink>
          </div>
          <div className="cgrocket">
            <Img
              cloudName={"controlgap"}
              imageName={"cg-website/objects/cg-rocket.png"}
              alt="controlgap rocket"
              fixed={{
                width: 300,
                height: 560,
              }}
              style={{ margin: "-100px auto" }}
              className="cgrocket"
            />
          </div>
        </div>
      </div>
      <section className="logo-carousel" style={{ paddingTop: "50px" }}>
        <h2 style={{ color: cgblue }}>Clients We Work With</h2>
        <AliceCarousel
          dotsDisabled={true}
          autoPlay={true}
          autoPlayInterval={3000}
          items={LogoSlides}
          responsive={{
            0: {
              items: 2,
            },
            1000: {
              items: 3,
            },
            1600: {
              items: 4,
            },
            2700: {
              items: 5,
            },
          }}
        ></AliceCarousel>
        <div className="container">
          <p style={{ color: "grey" }}>
            Are you interested in working together? <br /> Or would you like to
            know more about us?
          </p>
          <ContactUsButton text="LET'S TALK" />
        </div>
        <Img
          cloudName={"controlgap"}
          imageName={"cg-website/objects/cg-laptop-and-mug"}
          alt="laptop"
          fixed={{
            width: 698,
            height: 289,
          }}
          style={{ maxWidth: "100%", margin: "100px auto" }}
        />
      </section>
      <div style={{ color: "white" }}>
        <ContentBlock
          title="Contact Us"
          className="home-contact-us"
          cta={
            <>
              <h3>
                Cybersecurity Can Be Difficult.
                <br /> Let Us Guide You.
              </h3>
              <ContactForm from="Home-page Contact Form" />
              <span style={{ marginTop: "10px" }}>
                We will contact you within 24 hours.
              </span>
              <Img
                cloudName={"controlgap"}
                imageName={"cg-website/objects/cg-mouse"}
                alt="white computer mouse"
                fixed={{
                  width: 304,
                  height: 160,
                }}
                style={{
                  display: "block",
                  width: "300px",
                  maxWidth: "100%",
                  margin: "100px auto 50px",
                }}
              />
            </>
          }
        />
      </div>
    </Layout>
  )
}

export default IndexPage

const LogoSlides = Logos.map(logo => {
  return (
    <Img
      cloudName={"controlgap"}
      imageName={`cg-website/logos/${logo.src}.jpg`}
      fluid={{
        maxWidth: 256,
        height: 225,
      }}
    />
  )
  // return <img src={logo.src} alt={logo.alt} />
})

const IndexBlogPosts = ({ topThreePosts }) => {
  return topThreePosts.map(({ node }) => {
    const { excerpt, frontmatter } = node

    let coverImage = frontmatter.coverImage
      ? frontmatter.coverImage
      : "https://res.cloudinary.com/controlgap/image/upload/w_500,q_auto,f_auto/blog-images/controlgap-wall.jpg"

    const blogLink = `blog/${frontmatter.slug}`

    return (
      <div key={frontmatter.slug} className="blog-card">
        <div className="blog-head">
          <div className="tags">
            {frontmatter.tags.map(tag => (
              <span className="tag" key={tag}>
                {tag}{" "}
              </span>
            ))}
          </div>
          <h4>
            <AniLink fade to={blogLink}>
              {frontmatter.title}
            </AniLink>
          </h4>
          <span className="date">
            {moment(frontmatter.date).format("DD-MMM-YYYY")}
          </span>
          <p>{excerpt}</p>
          <a className="read-more" href={blogLink}>
            Read More >
          </a>
        </div>
        <AniLink
          className="blog-image-link"
          fade
          to={blogLink}
          style={{
            backgroundImage: `url(${coverImage})`,
          }}
        ></AniLink>
      </div>
    )
  })
}

function generateTestimonials(testimonials) {
  return testimonials.map(({ node: { quote, author, company } }) => (
    <div key={company}>
      <h3 style={{ width: "90%", maxWidth: "800px", margin: "10px auto" }}>
        "{quote}"
      </h3>
      <hr />
      <span>
        {author && `${author},`} <b>{company}</b>
      </span>
    </div>
  ))
}

function generateHomeServices(blocks) {
  return blocks.map(({ node: { title, icon, text, imageUrl, linkUrl } }) => (
    <div
      id={title}
      key={title}
      className={`${title} content-block text-image-block image-left `}
    >
      <div
        style={{
          backgroundImage: `url(https://res.cloudinary.com/controlgap/image/upload/q_auto,f_auto/${imageUrl}-background.jpg)`,
          color: "white",
        }}
      >
        <div
          className="container"
          style={{
            backgroundImage: `url(https://res.cloudinary.com/controlgap/image/upload/w_400,q_auto,f_auto/${imageUrl}-small.jpg)`,
          }}
        >
          <div className="text-content">
            <i style={{ paddingTop: "60px" }} className="control-gap">
              {icon}
            </i>
            <h2>{title}</h2>
            <p>{text}</p>
            <AniLink
              className="button-component"
              fade
              to={`/services/${linkUrl}`}
            >
              <span>FIND OUT MORE</span>
            </AniLink>
          </div>
          <div className="image-content"></div>
        </div>
      </div>
    </div>
  ))
}

export const query = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 2
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            coverImage
            title
            date
            slug
            tags
          }
        }
      }
    }
    allHomeServiceJson(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          title
          icon
          text
          linkUrl
          imageUrl
          position
        }
      }
    }
    allTestimonialsJson(sort: { order: ASC, fields: position }) {
      edges {
        node {
          quote
          author
          company
        }
      }
    }
  }
`
